// navigator.clipboard is undefined outside a secure context (e.g. local dev over http),
// so reading .writeText off it throws synchronously rather than rejecting a promise.
export const copyToClipboard = async (text: string): Promise<void> => {
  if (!navigator.clipboard) {
    throw new Error('Clipboard unavailable');
  }
  await navigator.clipboard.writeText(text);
};
